import { Link } from "react-router-dom";

type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-[12px] text-foreground-500 font-label">
      <Link to="/" className="cursor-pointer transition-colors hover:text-accent-400">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-600" />
          {item.to ? (
            <Link to={item.to} className="cursor-pointer transition-colors hover:text-accent-400">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-300">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}